import { ProviderInstanceProfileCountryModel } from './provider-instance-profile-country-model';

export class ProfileCountryCreateModel {
  countries: string[];
  expirationDate: Date|null;
  providerInstances: ProviderInstanceProfileCountryModel[];
}
